<template>
  <div class="footer-style">
    <div class="footer-font">
      <div class="uk-grid">
        <div class="uk-width-1-1 uk-width-3-4@m uk-text-left@m uk-text-center footer-text">
          &copy; {{smartCopyright}} |
          <a class="link-color" @click="redirect(legalLink)">{{$t('footer.terms')}}</a> | <a class="link-color"
                                                                                    @click="redirect(privacyLink)">{{$t('footer.privacy')}}</a>
        </div>
        <div class="uk-width-1-1 uk-width-1-4@m uk-text-right@m uk-text-center footer-text last-element">
          <a class="link-color" @click="redirect(smartLink)">www.smarttech.com</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import * as url from '../../enums/static-urls'
  export default {
    name: 'copyright-footer',
    data() {
      return {
        year: new Date().getFullYear(),
        legalLink: url.SMART_EXCHANGE_TERMS,
        smartLink: url.SMARTTECH,
        privacyLink: url.PRIVACY_POLICY
      }
    },
    methods: {
      redirect(url) {
        window.open(url, '_blank')
      }
    },
    computed: {
      smartCopyright() {
        return this.year + ' ' + this.$t('footer.copyright')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/breakpoints.scss';
  @import '../../styles/colours.scss';
  .footer-text {
    margin-top: 14px;
  }

  .link-color {
    color: $content-link-blue;
  }

  .footer-style {
    text-align: center;
    padding-left: 52px;
    padding-right: 49px;
    background-color: white;
    margin-top: 32px;
    max-height: 43px;
  }

  .footer-font {
    font-size: 12px;
    line-height: 1.48;
  }

  .last-element {
    margin-bottom: 10.2px;
  }

  @media screen and (min-width: $breakpoint-medium) {
    .footer-font {
      font-size: 14px;
    }
  }

  @media screen and (max-width: $breakpoint-small) {
    .footer-font {
      line-height: 1.55;
      font-size: 14px;
    }
  }

</style>
